import { entryChannels } from '@/mocks/home';

interface EntryChannelsProps {
  onEnter: (message: string) => void;
}

const badgeToneMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-800 border-primary-200',
  accent: 'bg-accent-100 text-accent-900 border-accent-300',
  secondary: 'bg-secondary-100 text-secondary-900 border-secondary-200',
};

export default function EntryChannels({ onEnter }: EntryChannelsProps) {
  return (
    <section id="entry" className="scroll-mt-20 border-b border-background-200 bg-background-100/60">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-6 md:py-16">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <h2 className="font-heading text-3xl text-foreground-950 md:text-4xl">极速入口通道</h2>
            <p className="mt-3 text-sm leading-7 text-foreground-700 md:text-base">
              六条线路长期在线，主线路拥堵时自动切换到备用，一键进入快速访问，不用再一遍遍搜索。
            </p>
          </div>
          <span className="shrink-0 self-start rounded-full border border-background-300 bg-background-50 px-3 py-1 text-xs text-foreground-600 md:self-auto">
            全部免注册 · 即点即走
          </span>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {entryChannels.map((channel) => (
            <div
              key={channel.id}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition hover:border-primary-300 hover:bg-primary-50/50"
            >
              <div className="flex items-start justify-between gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${channel.icon} text-xl`}></i>
                </span>
                <span
                  className={`shrink-0 rounded-full border px-2.5 py-0.5 text-[11px] ${badgeToneMap[channel.badgeTone]}`}
                >
                  {channel.badge}
                </span>
              </div>

              <h3 className="mt-4 font-heading text-lg text-foreground-950">{channel.name}</h3>
              <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600">{channel.desc}</p>

              <button
                type="button"
                onClick={() => onEnter(`正在通过「${channel.name}」秒进直达（演示）`)}
                className="mt-5 inline-flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-4 py-2 text-sm text-primary-700 transition group-hover:bg-primary-500 group-hover:text-background-50"
              >
                立即进入
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}